<h1 mat-dialog-title class="notification-title">{{ 'topbar.dialog.header' | translate }}</h1>
<div mat-dialog-content class="acies-dialog-content">
	<p>{{ 'topbar.dialog.content' | translate }} "{{ data }}"</p>
</div>
<div mat-dialog-actions class="acies-dialog-button-bar">
	<button mat-flat-button color="primary" (click)="onNoClick()" cdkFocusInitial>Ok</button>
</div>
